import React from "react";

import { styles } from "@common/styles";
import { IUser } from "@common/models";
import { random } from "@common";

export interface IUserListProps {
  users: IUser[];
  editUser: (user) => void;
}

class UserList extends React.Component<IUserListProps> {
  public render() {
    const { users } = this.props;

    const listItemStyle = { ...styles.listItem, flex: "8" };
    const companyItemStyle = { ...listItemStyle, width: "35%", flex: "7" };
    const clickableListItemStyle = { ...listItemStyle, cursor: "pointer" };
    const activeItemStyle = { ...listItemStyle, width: "10%", flex: "2" };
    const editLinkStyle = {
      ...listItemStyle,
      justifyContent: "flex-end",
      width: "15%",
      flex: "3"
    };

    return users.map((user, i) => {
      const uniqueKey = random();
      return (
        <div key={uniqueKey} style={styles.row as any} className="row">
          <div
            key={"Name_" + uniqueKey}
            onClick={() => this.props.editUser(user.userId)}
            style={clickableListItemStyle as any}
            title="Rediger bruker"
          >
            {user.name}
          </div>
          <div key={"Dep_" + uniqueKey} style={companyItemStyle as any}>
            {user.departmentName}
          </div>
          <div key={"IsActive_" + uniqueKey} style={activeItemStyle as any}>
            {user.isActive ? "Ja" : "Nei"}
          </div>
          <div key={"Edit_" + uniqueKey} style={editLinkStyle as any}>
            <div
              key={"EditLink_" + uniqueKey}
              onClick={() => this.props.editUser(user.userId)}
              style={styles.listLinkStyle as any}
              title="Rediger bruker"
            >
              Rediger
            </div>
          </div>
        </div>
      );
    });
  }
}

export default UserList;
